import { all } from 'typed-redux-saga'
import {
	rbidosAccessSaga,
	rbidosCommonSaga,
	rbidosAgentSaga,
} from 'Pages/registry_business_access_neo'

export function* registryBusinessAccessSaga() {
	yield* all([rbidosAccessSaga(), rbidosAgentSaga(), rbidosCommonSaga()])
}
